import React from 'react';

import LoginDialogue from 'sharedComponents/LoginDialogue';
import { Theme } from 'helpers/theme';
import environment, { setSessionStatus } from 'api/environment';
import { createUseStyles, useTheme } from 'react-jss';
import { commitMutation, graphql, createFragmentContainer } from 'react-relay';
import { GraphError } from 'types/general';
import { useRouter, Router } from 'found';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    background: '#f7f9fb',
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const mutation = graphql`
  mutation LoginPage_LoginMutation($email: String!, $password: String!) {
    managerLogin(input: { email: $email, password: $password }) {
      token
    }
  }
`;

const AttemptLogin = (router: Router, redirect?: string) => (
  email: string,
  password: string,
  errorCallback: (err: string) => void
) => {
  const variables = {
    email,
    password
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: async (
      response: { managerLogin: { token: string } },
      errors: GraphError[]
    ) => {
      if (errors) {
        // Display error
        errorCallback(`${errors[0]?.extensions?.message}`);
        return;
      }
      // The auth guard's cached status is now stale — mark the session
      // live so the destination route renders instead of holding blank
      setSessionStatus('loggedIn');

      // Return to the page that prompted the login (e.g. an email deep
      // link), only ever a same-origin path
      const target =
        redirect && redirect.startsWith('/') && !redirect.startsWith('//')
          ? redirect
          : '/app';
      router.push(target);
    },
    onError: (err) => errorCallback(`${err}`)
  });
};

const LoginPage = () => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const { router, match } = useRouter();
  const redirect = match.location.query?.redirect;

  return (
    <>
      <div className={classes.root}>
        <LoginDialogue isManager onSubmit={AttemptLogin(router, redirect)} />
      </div>
    </>
  );
};

export default createFragmentContainer(LoginPage, {
  manager: graphql`
    fragment LoginPage_manager on Manager {
      firstName
      lastName
    }
  `
});
